import { FC, useMemo, useState } from 'react';
import { useGetHeroConversationById } from '@vs-online-only-app/state';
import { SnackAlert } from '@vs-online-only-app/ui';

export enum SuccessBannerType {
  NewConversation = 'newConversation',
  Transfer = 'transfer',
}

type Props = {
  type: SuccessBannerType;
  conversationId: string;
  requesterId: string;
  onClose?: () => void;
};

const SuccessBanner: FC<Props> = ({
  type,
  conversationId,
  requesterId,
  onClose,
}) => {
  const [isVisible, setIsVisible] = useState<boolean>(true);

  const { data: conversation } = useGetHeroConversationById(conversationId);

  const requesterFirstName = useMemo(
    () =>
      conversation?.participants.find(
        (participant) => participant.id === requesterId,
      )?.firstName,
    [conversation, requesterId],
  );

  const handleClose = () => {
    if (onClose) onClose();
    setIsVisible(false);
  };

  return (
    <SnackAlert
      severity="success"
      open={isVisible && Boolean(conversation) && Boolean(requesterFirstName)}
      handleClose={handleClose}
      message={
        <>
          {type === SuccessBannerType.NewConversation && (
            <>
              You claimed the chat with <strong>{requesterFirstName}</strong>.
            </>
          )}
          {type === SuccessBannerType.Transfer && (
            <>
              You accepted {requesterFirstName}&apos;s request to chat with{' '}
              <strong>{conversation?.conversationStarter.firstName}</strong>.
            </>
          )}
        </>
      }
    />
  );
};

export default SuccessBanner;
